import { render, staticRenderFns } from "./otherSemViewer.vue?vue&type=template&id=9807c304&scoped=true&"
import script from "./otherSemViewer.vue?vue&type=script&lang=js&"
export * from "./otherSemViewer.vue?vue&type=script&lang=js&"
import style0 from "./otherSemViewer.vue?vue&type=style&index=0&id=9807c304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9807c304",
  null
  
)

export default component.exports